import { apiOldBaseUrl, apiBaseUrl } from "utils/constants";
import { headers } from "./configs";

export const fetchWrapper = {
  getOld,
  get,
  postOld,
  post,
  _delete,
  _deleteOld,
};

const OLD_BASE_API_URL = apiOldBaseUrl;
const BASE_API_URL = apiBaseUrl;

async function get(API_ENDPOINT: string, signal?: AbortSignal) {
  return _get(API_ENDPOINT, BASE_API_URL, signal);
}

async function getOld(API_ENDPOINT: string, signal?: AbortSignal) {
  return _get(API_ENDPOINT, OLD_BASE_API_URL, signal);
}

async function _get(
  API_ENDPOINT: string,
  baseUrl: string,
  signal?: AbortSignal
) {
  const requestOptions = {
    headers,
    method: "GET",
    signal,
    credentials: "include" as RequestCredentials,
  };

  return fetch(baseUrl + API_ENDPOINT, requestOptions).then(handleResponse);
}

function _delete(API_ENDPOINT: string) {
  return _deleteOld(API_ENDPOINT, BASE_API_URL);
}

function _deleteOld(API_ENDPOINT: string, baseUrl = OLD_BASE_API_URL) {
  const requestOptions = {
    headers,
    method: "DELETE",
    //   body: JSON.stringify(body),
    credentials: "include" as RequestCredentials,
  };
  return fetch(baseUrl + API_ENDPOINT, requestOptions).then(handleResponse);
}

function post(API_ENDPOINT: string, body: any) {
  return _post(API_ENDPOINT, body, BASE_API_URL);
}

function postOld(API_ENDPOINT: string, body: any) {
  return _post(API_ENDPOINT, body, OLD_BASE_API_URL);
}

function _post(API_ENDPOINT: string, body: any, baseUrl = OLD_BASE_API_URL) {
  const requestOptions = {
    headers,
    method: "POST",
    body: JSON.stringify(body),
    credentials: "include" as RequestCredentials,
  };
  return fetch(baseUrl + API_ENDPOINT, requestOptions).then(handleResponse);
}

// helper functions
function handleResponse(response: any) {
  return response.text().then((text: string) => {
    let data: any = null;

    const contentType =
      response.headers && typeof response.headers.get === "function"
        ? response.headers.get("content-type") || "unknown"
        : "unknown";

    try {
      data = text ? JSON.parse(text) : null;
    } catch (err) {
      if (!response.ok) {
        // Reject with a generic server error message without logging here
        // (callers handle their own logging/Sentry capture)
        return Promise.reject(
          `Server error ${response.status}: ${response.statusText}`
        );
      }

      // Unexpected non-JSON on a successful response
      console.error("Failed to parse successful response as JSON", {
        parseError: err,
        status: response.status,
        contentType,
      });
      return Promise.reject(
        `Unexpected non-JSON response (status ${response.status}, content-type ${contentType})`
      );
    }

    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}